module.exports = "/assets/data/b5d4e5a5d986bfa3f89d92fe56920906-RG29.data.json";